import {connect} from 'react-redux'
import CustomerCard from '../components/CustomerCard'
import _ from 'lodash'

import {resetCustomer, resetCheckResult, resetCheckUploading} from '../modules/checkcashing'
import {resetScannerResult} from "../../../Devices/Scanner/modules/scanner";

const mapDispatchToProps = {
  resetCustomer,
  resetCheckUploading,
  resetCheckResult,
  resetScannerResult
};

const mapStateToProps = (state) => {
  const {
    s_customer_first_name, s_customer_middle_name, s_customer_last_name, s_customer_cell_phone, s_customer_address1,
    s_customer_city, s_customer_state, s_customer_zip, s_customer_photo, check_images_processing
  } = state.app.x_data;

  return {
    customer_name: [s_customer_first_name, s_customer_middle_name, s_customer_last_name].join(' '),
    customer_phone: s_customer_cell_phone,
    customer_address: `${[s_customer_address1, s_customer_city, s_customer_state].join(', ')} ${s_customer_zip}`,
    customer_photo: s_customer_photo,
    check_images_processing: check_images_processing
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerCard)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CustomerCardContainer.js